module.exports = __webpack_public_path__ + "static/img/845835beedbefae20f875463a5877c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_tphy.png
// module id = lKVK
// module chunks = 1